//#region IMPORT
import React, { useState } from 'react';
import {
  Box,
  Typography,
  Button,
  Chip,
  Tabs,
  Tab,
  Card,
  CardContent,
  IconButton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Radio,
  Paper,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import DeleteIcon from '@mui/icons-material/Delete';
import DownloadIcon from '@mui/icons-material/Download';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { Combo } from '../../../../../Components/MUIs';
import BackClickBottomSheet from '../../../../../Components/BottomSheet/BackClickBottomSheet';
import { showSnackbar } from '../../../../../Reducer/SnackbarReducer';
//#endregion

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

function M_TRA_CUSTOM_03(props) {
  const {
    ToggleDrawer,
    bottomSheetState,
    id,
    custInfo,
    tempFileList,
    departmentList,
    selectedDepCd,
    videoInputRef,
    materialInputRef,
    dispatch,
    HandleWorkplaceChange,
    HandleVideoUpload,
    HandleSave,
    HandleRemoveVideo,
    HandleRemoveMaterial,
    HandleMaterialUpload,
    GetFinalSelectedItems,
    RenderPreview,
    HandleFileListDelete,
    HandleFileListDownload,
    HandleTempFileRowClick,
    HandleDepartmentSelect,
    tabValue,
    setTabValue,
  } = props;

  return (
    <Box
      sx={{
        height: 'calc(100vh - 56px)',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          px: 2,
          py: 2,
          gap: 2,
          overflowY: 'auto',
          overflowX: 'hidden',
          WebkitOverflowScrolling: 'touch', // iOS 부드러운 스크롤
        }}
      >
        {/* 사업장 선택 섹션 */}
        <Box sx={{ flexShrink: 0 }}>
          <Typography
            sx={{
              fontSize: '18px',
              fontWeight: 'bold',
              mb: 1.5,
              color: '#0D843F',
            }}
          >
            사업장 선택
          </Typography>
          <Combo
            name="사업장을 선택하세요"
            items={custInfo.custList}
            value={custInfo.custCd}
            onChange={HandleWorkplaceChange}
            wrapSx={{ width: '100%' }}
            disabled={id}
          />
        </Box>

        {/* 부서 선택 섹션 */}
        <Box sx={{ flexShrink: 0, mt: 2 }}>
          <Typography
            sx={{
              fontSize: '18px',
              fontWeight: 'bold',
              mb: 1.5,
              color: '#0D843F',
            }}
          >
            부서 선택
          </Typography>

          {/* 부서 선택 테이블 */}
          <TableContainer
            component={Paper}
            sx={{
              maxHeight: '300px',
              borderRadius: '8px',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              border: '1px solid #e0e0e0',
            }}
          >
            <Table stickyHeader size="small">
              <TableHead>
                <TableRow>
                  <TableCell
                    align="center"
                    sx={{
                      fontWeight: 'bold',
                      backgroundColor: '#f5f5f5',
                      width: '50px',
                      minWidth: '50px',
                    }}
                  >
                    선택
                  </TableCell>
                  <TableCell
                    align="left"
                    sx={{
                      fontWeight: 'bold',
                      backgroundColor: '#f5f5f5',
                    }}
                  >
                    본부
                  </TableCell>
                  <TableCell
                    align="left"
                    sx={{
                      fontWeight: 'bold',
                      backgroundColor: '#f5f5f5',
                    }}
                  >
                    부서
                  </TableCell>
                  <TableCell
                    align="left"
                    sx={{
                      fontWeight: 'bold',
                      backgroundColor: '#f5f5f5',
                    }}
                  >
                    팀
                  </TableCell>
                  <TableCell
                    align="left"
                    sx={{
                      fontWeight: 'bold',
                      backgroundColor: '#f5f5f5',
                    }}
                  >
                    파트
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {departmentList && departmentList.length > 0 ? (
                  departmentList.map((dept, index) => (
                    <TableRow
                      key={dept.DEP_CD || index}
                      hover
                      sx={{
                        cursor: 'pointer',
                        backgroundColor:
                          selectedDepCd === dept.DEP_CD
                            ? '#e3f2fd'
                            : 'transparent',
                        '&:hover': {
                          backgroundColor:
                            selectedDepCd === dept.DEP_CD
                              ? '#bbdefb'
                              : '#f5f5f5',
                        },
                      }}
                      onClick={() => {
                        if (!id) {
                          HandleDepartmentSelect(dept.DEP_CD);
                        }
                      }}
                    >
                      <TableCell align="center" sx={{ width: '50px' }}>
                        <Radio
                          checked={selectedDepCd === dept.DEP_CD}
                          onChange={() => {
                            if (!id) {
                              HandleDepartmentSelect(dept.DEP_CD);
                            }
                          }}
                          disabled={id}
                          size="small"
                          sx={{
                            color: '#1976d2',
                            '&.Mui-checked': {
                              color: '#1976d2',
                            },
                          }}
                        />
                      </TableCell>
                      <TableCell
                        align="left"
                        sx={{
                          fontWeight:
                            selectedDepCd === dept.DEP_CD ? 'bold' : 'normal',
                          color:
                            selectedDepCd === dept.DEP_CD ? '#1976d2' : '#333',
                        }}
                      >
                        {dept.DEP_NM1 || '-'}
                      </TableCell>
                      <TableCell
                        align="left"
                        sx={{
                          fontWeight:
                            selectedDepCd === dept.DEP_CD ? 'bold' : 'normal',
                          color:
                            selectedDepCd === dept.DEP_CD ? '#1976d2' : '#333',
                        }}
                      >
                        {dept.DEP_NM2 || '-'}
                      </TableCell>
                      <TableCell
                        align="left"
                        sx={{
                          fontWeight:
                            selectedDepCd === dept.DEP_CD ? 'bold' : 'normal',
                          color:
                            selectedDepCd === dept.DEP_CD ? '#1976d2' : '#333',
                        }}
                      >
                        {dept.DEP_NM3 || '-'}
                      </TableCell>
                      <TableCell
                        align="left"
                        sx={{
                          fontWeight:
                            selectedDepCd === dept.DEP_CD ? 'bold' : 'normal',
                          color:
                            selectedDepCd === dept.DEP_CD ? '#1976d2' : '#333',
                        }}
                      >
                        {dept.DEP_NM4 || '-'}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell
                      colSpan={5}
                      align="center"
                      sx={{ py: 3, color: 'text.secondary' }}
                    >
                      부서가 없습니다.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          {/* 등록 대상 목록 */}
          {selectedDepCd && (
            <Box sx={{ mt: 2 }}>
              <Typography
                sx={{
                  fontSize: '15px',
                  fontWeight: 'bold',
                  mb: 1,
                  color: '#0D843F',
                }}
              >
                선택된 부서
              </Typography>
              <Box
                sx={{
                  border: '1px solid #e0e0e0',
                  borderRadius: '8px',
                  p: 1.5,
                  backgroundColor: '#f9f9f9',
                  minHeight: '50px',
                }}
              >
                {GetFinalSelectedItems().length > 0 ? (
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                    {GetFinalSelectedItems().map((item) => (
                      <Chip
                        key={item.id}
                        label={item.name}
                        size="small"
                        sx={{
                          backgroundColor: item.backgroundColor,
                          color: item.color,
                          fontWeight: 'bold',
                          fontSize: '12px',
                        }}
                      />
                    ))}
                  </Box>
                ) : (
                  <Typography
                    sx={{
                      color: '#999',
                      fontSize: '13px',
                      textAlign: 'center',
                      py: 1,
                    }}
                  >
                    선택된 부서가 없습니다.
                  </Typography>
                )}
              </Box>
            </Box>
          )}
        </Box>

        {/* 탭 영역 */}
        <Box
          sx={{ flexShrink: 0, mt: 2, borderBottom: 1, borderColor: 'divider' }}
        >
          <Typography
            sx={{
              fontSize: '18px',
              fontWeight: 'bold',
              mb: 1.5,
              color: '#0D843F',
            }}
          >
            교육 자료 업로드
          </Typography>
          <Tabs
            value={tabValue}
            onChange={(e, newValue) => setTabValue(newValue)}
            sx={{
              '& .MuiTabs-indicator': {
                height: 3,
                borderRadius: '3px 3px 0 0',
              },
            }}
          >
            <Tab
              label="📄 교육자료"
              sx={{
                fontWeight: 'bold',
                fontSize: '15px',
                minHeight: 48,
                color: tabValue === 0 ? '#9c27b0' : '#666',
                '&.Mui-selected': {
                  color: '#9c27b0',
                },
              }}
            />
            <Tab
              label="📹 교육동영상"
              sx={{
                fontWeight: 'bold',
                fontSize: '15px',
                minHeight: 48,
                color: tabValue === 1 ? '#1976d2' : '#666',
                '&.Mui-selected': {
                  color: '#1976d2',
                },
              }}
            />
          </Tabs>
        </Box>

        {/* 파일 업로드 섹션 */}
        <Box sx={{ flexShrink: 0 }}>
          <Typography
            sx={{
              fontSize: '18px',
              fontWeight: 'bold',
              mb: 1.5,
              color: tabValue === 0 ? '#9c27b0' : '#1976d2',
            }}
          >
            {tabValue === 0 ? '📄 교육 자료 업로드' : '📹 교육 동영상 업로드'}
          </Typography>
          <Box
            sx={{
              border: '2px dashed #ccc',
              borderRadius: '8px',
              p: 2,
              textAlign: 'center',
              backgroundColor: '#f9f9f9',
              mb: 2,
            }}
          >
            <Button
              variant="contained"
              component="label"
              startIcon={<CloudUploadIcon />}
              sx={{
                backgroundColor: tabValue === 0 ? '#9c27b0' : '#1976d2',
                '&:hover': {
                  backgroundColor: tabValue === 0 ? '#7b1fa2' : '#1565c0',
                },
                mb: 1,
              }}
            >
              {tabValue === 0 ? '자료 선택' : '동영상 선택'}
              <VisuallyHiddenInput
                ref={tabValue === 0 ? materialInputRef : videoInputRef}
                type="file"
                accept={
                  tabValue === 0
                    ? '.pdf,.doc,.docx,.ppt,.pptx,.xls,.xlsx,.png,.jpg,.jpeg,.hwp'
                    : 'video/*'
                }
                onChange={
                  tabValue === 0 ? HandleMaterialUpload : HandleVideoUpload
                }
                multiple
              />
            </Button>
            <Typography
              variant="caption"
              sx={{
                color: '#666',
                display: 'block',
                fontSize: '12px',
              }}
            >
              {tabValue === 0
                ? 'PDF, HWP, DOC, DOCX, XLS, XLSX, PPT, PPTX 형식 지원'
                : 'MP4, AVI, MOV 형식 지원'}
            </Typography>
          </Box>

          {/* 업로드된 파일 목록 */}
          {tempFileList &&
            tempFileList.filter(
              (f) => f.type === (tabValue === 0 ? 'edu' : 'video')
            ).length > 0 && (
              <Box>
                <Typography
                  sx={{ fontSize: '14px', fontWeight: 'bold', mb: 1 }}
                >
                  업로드된 파일 목록
                </Typography>
                <Stack spacing={1}>
                  {tempFileList
                    .filter(
                      (f) => f.type === (tabValue === 0 ? 'edu' : 'video')
                    )
                    .map((file, index) => (
                      <Card
                        key={file.id || index}
                        sx={{
                          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                          borderRadius: '8px',
                          '&:hover': {
                            boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
                          },
                        }}
                      >
                        <CardContent
                          sx={{
                            p: 1.5,
                            '&:last-child': { pb: 1.5 },
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            cursor: 'pointer',
                          }}
                          onClick={() => HandleTempFileRowClick?.(file)}
                        >
                          <Box sx={{ flex: 1, minWidth: 0 }}>
                            <Typography
                              sx={{
                                fontSize: '14px',
                                fontWeight: 'bold',
                                mb: 0.5,
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                              }}
                            >
                              {file.fileName}
                            </Typography>
                            <Typography
                              variant="caption"
                              sx={{ color: '#666', fontSize: '12px' }}
                            >
                              {file.regDate || '-'}
                              {file.file?.size &&
                                ` • ${(file.file.size / 1024 / 1024).toFixed(
                                  2
                                )} MB`}
                            </Typography>
                          </Box>
                          <Box sx={{ display: 'flex', gap: 0.5 }}>
                            {file.filePath && (
                              <IconButton
                                size="small"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  HandleFileListDownload?.(file);
                                }}
                                sx={{
                                  color: '#1976d2',
                                  '&:hover': {
                                    backgroundColor: '#e3f2fd',
                                  },
                                }}
                              >
                                <DownloadIcon fontSize="small" />
                              </IconButton>
                            )}
                            <IconButton
                              size="small"
                              onClick={(e) => {
                                e.stopPropagation();
                                HandleFileListDelete?.(file);
                              }}
                              sx={{
                                color: '#d32f2f',
                                '&:hover': {
                                  backgroundColor: '#ffebee',
                                },
                              }}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </Box>
                        </CardContent>
                      </Card>
                    ))}
                </Stack>
              </Box>
            )}
        </Box>

        {/* 미리보기 영역 */}
        {tempFileList &&
          tempFileList.filter(
            (f) => f.type === (tabValue === 0 ? 'edu' : 'video')
          ).length > 0 && (
            <Box
              sx={{
                flexShrink: 0,
                height: '300px',
                border: '1px dashed #ccc',
                borderRadius: '8px',
                overflow: 'auto',
                backgroundColor: '#fafafa',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                p: 2,
                mb: 2,
              }}
            >
              {tabValue === 0 ? (
                RenderPreview ? (
                  RenderPreview()
                ) : (
                  <Typography variant="body2" color="text.secondary">
                    파일을 선택하면 미리보기가 표시됩니다.
                  </Typography>
                )
              ) : (
                <Box sx={{ width: '100%', textAlign: 'center' }}>
                  <Typography variant="body2" color="text.secondary">
                    동영상 미리보기 영역
                  </Typography>
                </Box>
              )}
            </Box>
          )}
      </Box>

      {/* 저장 버튼 (고정) */}
      <Box
        sx={{
          flexShrink: 0,
          px: 2,
          pb: 2,
          pt: 1,
          backgroundColor: '#fff',
          borderTop: '1px solid #e0e0e0',
        }}
      >
        <Button
          variant="contained"
          fullWidth
          sx={{
            backgroundColor: '#57B84D',
            '&:hover': { backgroundColor: '#4A9B42' },
            py: 1.5,
            height: 48,
            fontSize: '16px',
            fontWeight: 'bold',
          }}
          onClick={async () => {
            if (!custInfo.custCd) {
              dispatch(
                showSnackbar({
                  message: '사업장을 선택해주세요.',
                  type: 'warning',
                })
              );
              return;
            }

            if (
              !tempFileList ||
              tempFileList.filter(
                (f) => f.type === (tabValue === 0 ? 'edu' : 'video')
              ).length === 0
            ) {
              dispatch(
                showSnackbar({
                  message: `${
                    tabValue === 0 ? '교육 자료' : '동영상'
                  }을 업로드해주세요.`,
                  type: 'warning',
                })
              );
              return;
            }

            if (!selectedDepCd) {
              dispatch(
                showSnackbar({
                  message: '부서를 선택해주세요.',
                  type: 'warning',
                })
              );
              return;
            }

            if (HandleSave) {
              const success = await HandleSave();
              if (success) {
                // 성공 시 폼 초기화는 부모 컴포넌트에서 처리
              }
            }
          }}
        >
          자료 등록
        </Button>
      </Box>

      {/* 바텀시트 */}
      {bottomSheetState.bottom && bottomSheetState.type === 'backClickTra' && (
        <BackClickBottomSheet
          open={true}
          ToggleDrawer={ToggleDrawer}
          route={'/M_TrainingPage'}
        />
      )}
    </Box>
  );
}

export default M_TRA_CUSTOM_03;
